import { ShieldX } from "lucide-react"
import { useNavigate } from "react-router-dom"
import { useTranslation } from 'react-i18next'
import { Button } from "@/components/ui/button"
import { useAuthStore } from "@/stores/auth-store"

export default function UnauthorizedPage() {
  const { t } = useTranslation()
  const navigate = useNavigate()
  const logout = useAuthStore((state) => state.logout)

  function handleLogout() {
    logout()
    navigate("/login", { replace: true })
  }

  return (
    <div className="flex min-h-svh flex-col items-center justify-center gap-6 p-6">
      <div className="flex flex-col items-center gap-2 text-center">
        <div className="flex size-16 items-center justify-center rounded-full bg-destructive/10">
          <ShieldX className="size-8 text-destructive" />
        </div>
        <h1 className="text-2xl font-bold">{t('unauthorized.title')}</h1>
        <p className="text-muted-foreground text-sm text-balance max-w-md">
          {t('unauthorized.message')}
        </p>
      </div>
      <div className="flex gap-3">
        <Button variant="outline" onClick={() => navigate(-1)}>
          {t('unauthorized.goBack')}
        </Button>
        <Button variant="destructive" onClick={handleLogout}>
          {t('unauthorized.goToLogin')}
        </Button>
      </div>
    </div>
  )
}
